(function () {
 function globalize(modal) {
   if (!modal) return;
   if (modal.parentElement !== document.body) document.body.appendChild(modal);
 }

 function allInfluencerModals() {
   return Array.from(document.querySelectorAll('[data-influencer-modal]'));
 }

 function resetInfluencerModal(modal) {
   if (!modal) return;

   modal.querySelectorAll('.influencer-modal__profile-tab').forEach(function (button) {
     button.classList.remove('is-active');
     button.setAttribute('aria-selected', 'false');
   });

   var creatorButton = modal.querySelector(
     '.influencer-modal__profile-tab:not([data-klf-profile-switch])'
   );

   if (creatorButton) {
     creatorButton.classList.add('is-active');
     creatorButton.setAttribute('aria-selected', 'true');
   }

   var creatorPanel = modal.querySelector('[data-profile-panel="creator"]');
   if (creatorPanel) creatorPanel.hidden = false;
 }

 function modalByProfile(profileId) {
   if (!profileId) return null;
   return allInfluencerModals().find(function (modal) {
     return modal.getAttribute('data-influencer-profile-id') === profileId ||
            modal.getAttribute('data-profile-id') === profileId;
   }) || null;
 }

 function modalByParticipant(participantId) {
   if (!participantId) return null;
   return allInfluencerModals().find(function (modal) {
     return modal.getAttribute('data-participant-id') === participantId;
   }) || null;
 }

 function anotherSharedLayerIsOpen() {
   return Boolean(document.querySelector(
     '[data-author-modal].is-open,' +
     '[data-influencer-modal]:not([hidden]),' +
     '[data-professional-modal]:not([hidden]),' +
     '[data-catalog-modal].is-open,' +
     '[data-klf-shared-catalog].is-open,' +
     '[data-klf-book-modal]:not([hidden]),' +
     '[data-book-modal]:not([hidden])'
   ));
 }

 function syncBodyLock() {
   document.body.classList.toggle('kinfolk-modal-open', anotherSharedLayerIsOpen());
 }

 function openInfluencerModal(modal, trigger) {
   if (!modal || modal.getAttribute('data-list-on-site') === 'false') return false;

   /*
     Canonical rule: profile roots live at document.body while open.
     This prevents an Influencer modal rendered as a sibling identity inside
     Author or Professional markup from being hidden when the launching
     profile is dismissed. The page that launched the profile is irrelevant.
   */
   globalize(modal);
   resetInfluencerModal(modal);

   allInfluencerModals().forEach(function (otherModal) {
     if (otherModal === modal) return;
     otherModal.hidden = true;
     otherModal.classList.remove('is-open');
     otherModal.setAttribute('aria-hidden', 'true');
   });

   if (trigger) modal._kinfolkReturnTrigger = trigger;

   modal.hidden = false;
   modal.classList.add('is-open');
   modal.setAttribute('aria-hidden', 'false');
   syncBodyLock();

   var dialog = modal.querySelector('.influencer-modal__dialog');
   if (dialog) {
     dialog.scrollTop = 0;
     window.setTimeout(function () {
       try { dialog.focus({ preventScroll:true }); }
       catch (error) { try { dialog.focus(); } catch (ignore) {} }
     }, 0);
   }

   return true;
 }

 function closeInfluencerModal(modal, restoreFocus) {
   if (!modal) return false;

   modal.hidden = true;
   modal.classList.remove('is-open');
   modal.setAttribute('aria-hidden', 'true');
   syncBodyLock();

   if (
     restoreFocus !== false &&
     modal._kinfolkReturnTrigger &&
     typeof modal._kinfolkReturnTrigger.focus === 'function'
   ) {
     try { modal._kinfolkReturnTrigger.focus(); } catch (error) {}
   }

   return true;
 }

 window.KLFInfluencerModalOpen = function (modalOrId, trigger) {
   var modal = typeof modalOrId === 'string'
     ? document.getElementById(modalOrId)
     : modalOrId;
   return openInfluencerModal(modal, trigger || null);
 };

 window.KLFInfluencerModalOpenByInfluencerProfile = function (profileId, trigger) {
   return openInfluencerModal(modalByProfile(profileId), trigger || null);
 };

 window.KLFInfluencerModalOpenByParticipant = function (participantId, trigger) {
   return openInfluencerModal(modalByParticipant(participantId), trigger || null);
 };

 window.KLFInfluencerModalClose = function (modalOrId) {
   var modal = typeof modalOrId === 'string'
     ? document.getElementById(modalOrId)
     : modalOrId;
   return closeInfluencerModal(modal, true);
 };

 /*
   Influencer owns only its own close behavior.
   Author / Professional profile switches are owned exclusively by
   KLFProfileModal through data-klf-profile-switch.
 */
 document.addEventListener('click', function (event) {
   if (event.target.closest('[data-klf-profile-switch]')) return;

   var closeControl = event.target.closest('[data-influencer-modal-close]');
   if (!closeControl) return;

   var modal = closeControl.closest('[data-influencer-modal]');
   if (!modal) return;

   event.preventDefault();
   event.stopPropagation();
   closeInfluencerModal(modal, true);
 });

 document.addEventListener('keydown', function (event) {
   if (event.key !== 'Escape') return;
   var modal = document.querySelector('[data-influencer-modal]:not([hidden])');
   if (!modal) return;
   event.preventDefault();
   closeInfluencerModal(modal, true);
 });

 function initialize() {
   allInfluencerModals().forEach(globalize);
 }

 if (document.readyState === 'loading') {
   document.addEventListener('DOMContentLoaded', initialize, { once:true });
 } else {
   initialize();
 }

 document.addEventListener('shopify:section:load', initialize);
})();
